module.exports = __webpack_public_path__ + "assets/img/IMG021.03609107.png";